<div class="container-fluid">
  <div class="row top10 ">
    <div class="col-xs-12 ">
      <h3>Traveler Config</h3>
    </div>
  </div>
  <hr style="margin-top: 2px; margin-bottom: 2px" />

  <div class="row top10">
    <mat-tab-group>

      <mat-tab label="Traveler Status">
        <div class="table-container">
          <aims-common-table
            id="travelerStatusConfigTable"
            [dataSource]="travelerStatuses"
            [header]="travelerStatusTableColumns"
            [permissions]="travelerStatusTablePermissions"
            [addRowInitialObject]="initialTravelerStatusTableObject "
            (rowUpdated)="handleTravelerStatusRowUpdate($event)"
            (rowAdded)="handleTravelerStatusRowCreate($event)"
            [stickyHeader]="true"
          >
          </aims-common-table>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>

  <aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"></aims-spinner>
</div>
